"use client";

import { useEffect } from "react";

import type { ReactNode } from "react";
import type { Article } from "../../../../types/content";

import { usePulse } from "../../../../pulse/usePulse";
import { getHref } from "../SalesPosterContainer/helper";
import { useIntersectionObserver } from "../../../../hooks/useIntersectionObserver/useIntersectionObserver";

const PulseTrackPremiumInformationBoxImpression = ({
  children,
  isOmniEconomy,
  article,
}: {
  children: ReactNode;
  isOmniEconomy: boolean;
  article?: Article;
}) => {
  const { trackPremiumInformationBoxImpression } = usePulse();
  const { ref, inView } = useIntersectionObserver({
    threshold: 2 / 3,
  });

  useEffect(() => {
    if (inView) {
      const href = getHref(isOmniEconomy, article);
      trackPremiumInformationBoxImpression(href);
    }
  }, [inView, isOmniEconomy, trackPremiumInformationBoxImpression, article]);

  return <div ref={ref}>{children}</div>;
};

export { PulseTrackPremiumInformationBoxImpression };
